var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 31.43
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.503 0a11.646 11.646 0 0 1 11.379 9.738 10.8 10.8 0 0 1-.872 5.951 45.5 45.5 0 0 1-4.672 8.393c-1.589 2.312-3.27 4.562-4.924 6.829a1.036 1.036 0 0 1-1.764.054 87 87 0 0 1-8.111-12.064A23.6 23.6 0 0 1 .27 13.435a9.72 9.72 0 0 1 .7-6.463A11.25 11.25 0 0 1 9.236.288C9.981.124 10.748.092 11.503 0m.023 14.687a4.19 4.19 0 0 0 4.168-4.154 4.185 4.185 0 0 0-4.18-4.208 4.185 4.185 0 0 0-4.184 4.2 4.19 4.19 0 0 0 4.196 4.162"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.526 14.687a4.19 4.19 0 0 1-4.2-4.159 4.185 4.185 0 0 1 4.184-4.2 4.185 4.185 0 0 1 4.18 4.208 4.19 4.19 0 0 1-4.164 4.151"
  })));
};
export default SvgMapPin;